import { useCallback, useEffect, useState } from 'react';

import { useAtualizarCondutor } from '@hooks/condutor/useAtualizarCondutor';
import { useCondutor } from '@hooks/condutor/useCondutor';
import { useRestaurarCondutor } from '@hooks/condutor/useRestaurarCondutor';

import { GestaoCondutor } from './GestaoCondutor';

import type { DadosCondutor } from '@services/detran/condutor.service';

export const GestaoCondutorContainer = () => {
  const [cpf, setCpf] = useState('');
  const [cpfConsultado, setCpfConsultado] = useState('');
  const [formValues, setFormValues] = useState<DadosCondutor>({});

  const condutorQuery = useCondutor(cpfConsultado);
  const atualizar = useAtualizarCondutor();
  const restaurar = useRestaurarCondutor();

  // O formulário reflete o cadastro recém-carregado — inclusive depois de
  // salvar, quando a query é invalidada e traz o dado já alterado.
  useEffect(() => {
    const dados = condutorQuery.data;

    if (!dados) return;

    setFormValues(Object.fromEntries(dados.camposEditaveis.map(({ field }) => [field, dados.dados[field]])));
  }, [condutorQuery.data]);

  const handleBuscar = useCallback(() => {
    atualizar.reset();
    setCpfConsultado(cpf);
  }, [atualizar, cpf]);

  const handleFieldChange = useCallback((field: string, value: string | number | boolean) => {
    setFormValues((current) => ({ ...current, [field]: value }));
  }, []);

  const handleRestaurar = useCallback(() => {
    atualizar.reset();
    restaurar.mutate({ cpf: cpfConsultado });
  }, [atualizar, cpfConsultado, restaurar]);

  const handleSalvar = useCallback(() => {
    atualizar.mutate({ cpf: cpfConsultado, changes: formValues });
  }, [atualizar, cpfConsultado, formValues]);

  return (
    <GestaoCondutor
      cpf={cpf}
      onCpfChange={setCpf}
      onBuscar={handleBuscar}
      dados={condutorQuery.data?.dados}
      camposEditaveis={condutorQuery.data?.camposEditaveis ?? []}
      buscando={condutorQuery.isFetching}
      erroBusca={condutorQuery.isError}
      formValues={formValues}
      onFieldChange={handleFieldChange}
      onSalvar={handleSalvar}
      salvando={atualizar.isPending}
      resultado={atualizar.data}
      erroSalvar={atualizar.error?.message ?? restaurar.error?.message}
      onRestaurar={handleRestaurar}
      restaurando={restaurar.isPending}
    />
  );
};
